module.exports = __webpack_public_path__ + "static/media/Flag_of_Ohio.6d0acf2b.svg";